import React from 'react'
import { useRef } from 'react'
import { AiFillLinkedin } from 'react-icons/ai'
import { AiFillGithub } from 'react-icons/ai'
import { AiOutlineTwitter } from 'react-icons/ai'
import { AiOutlineMail } from 'react-icons/ai'
import emailjs from '@emailjs/browser';
// import { useFormik } from 'formik'

export const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_l9lefwh', 'template_dupo72b', form.current, 'Ekj9kpX6_PhX1CrV2')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    // formik logic
    // const formik = useFormik({
    //     initialValues: {
    //         name: "",
    //         email: "",
    //         message: "",
    //     },
    // });
    // console.log(formik.values);

    return (
        <section className="bg-[#021227] px-7 sm:px-14 py-16 max-w-screen-xl mx-auto" id="contact">
            <div className="flex items-center justify-center gap-12 pb-12">
                <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                <h2 className="text-4xl font-bold ">Get In Touch</h2>
                <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
            </div>
            <div className="bg-whte rounded-xl shadow-lg p-8 text-gray-600">
                <form action="" ref={form} onSubmit={sendEmail} className="flex flex-col space-y-4">
                    <div className="relative z-0 w-full mb-2 group">
                        <input type="tex" name="user_name" id="floating_text"
                            className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-[#309543] dark:focus:border-[#309543] focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            placeholder=" " required />
                        <label htmlFor="floating_email"
                            className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-[#309543] duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-[#309543] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Your
                            Name</label>
                    </div>
                    <div className="relative z-0 w-full mb-6 group">
                        <input type="email" name="user_email" id="floating_email"
                            className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-[#309543] dark:focus:border-[#309543] focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            placeholder=" " required />
                        <label htmlFor="floating_email"
                            className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-[#309543] duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-[#309543] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Email
                            address</label>
                    </div>
                    <div>
                        <div className="relative z-0 w-full mb-6 group">
                            <textarea name="user_message" id="floating_text"
                                className="block py-0 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-[#309543] dark:focus:border-[#309543] focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                placeholder=" " required />
                            <label htmlFor="floating_text"
                                className="peer-focus:font-medium absolute text-sm text-[#309543] dark:text-[#309543] duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-[#309543] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Leave
                                Message</label>
                        </div>

                    </div>
                    <button className="inline-block self-end bg-[#30954232] text-[#309543] hover:bg-[#309543] hover:text-white font-bold border-none border-[#309543] rounded-lg px-6 py-2 uppercase text-sm">Leave Message</button>
                    {/* <button type="submit" className="inline-block self-end text-[#309543] bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 
            font-medium border border-[#309543] rounded-lg text-sm px-5 py-2.5 text-center dark:bg-[#30954232] dark:hover:bg-[#30954232] transition-all duration-300
            dark:focus:ring-[#309543]">Leave Message</button> */}
                </form>
            </div>
            <div className="mt-12 flex justify-center">
                <ul className="flex gap-4">
                    <li className="mr-2 flex justify-center items-center">
                        <a href="mailto: olasunkanmiabdullateef@gmail.com" target="_blank" rel="noopener noreferrer" className="w-[35px] h-[35px]">
                            <AiOutlineMail name='mail' className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
                        </a>
                    </li>
                    <li className="mr-2 flex justify-center items-center">
                        <a href="https://www.linkedin.com/in/abdullateef-kolawole/" target="_blank" rel="noopener noreferrer" className="w-[35px] h-[35px]">
                            <AiFillLinkedin name='logo-linkedin' className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
                        </a>
                    </li>
                    <li className="mr-2 flex justify-center items-center">
                        <a href="https://github.com/BrainiacDev" target="_blank" rel="noopener noreferrer" className="w-[35px] h-[35px]">
                            <AiFillGithub name='logo-github' className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
                        </a>
                    </li>
                    <li className="mr-2 flex justify-center items-center">
                        <a href="https://twitter.com/Holarzkid12" target="_blank" rel="noopener noreferrer" className="w-[35px] h-[35px]">
                            <AiOutlineTwitter name="logo-twitter" className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
                        </a>
                    </li>

                </ul>
            </div>
        </section >
    )
}
